import { render, staticRenderFns } from "./UploadImportacaoModal.vue?vue&type=template&id=5ed4c42c&scoped=true"
import script from "./UploadImportacaoModal.vue?vue&type=script&lang=js"
export * from "./UploadImportacaoModal.vue?vue&type=script&lang=js"
import style0 from "./UploadImportacaoModal.vue?vue&type=style&index=0&id=5ed4c42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed4c42c",
  null
  
)

export default component.exports